/* MacDanny Fashion — continuous auto-scroll for the reviews rail.
   Scrolls horizontally in a seamless loop and pauses on hover, focus or touch. */
(function () {
  'use strict';
  function init(wrap) {
    if (wrap.dataset.autoscrollReady) return;
    wrap.dataset.autoscrollReady = '1';
    var rail = wrap.querySelector('[data-rail-track]');
    if (!rail || rail.children.length < 2) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var speed = parseFloat(wrap.getAttribute('data-autoscroll-speed') || '40'); // px per second
    var originals = Array.prototype.slice.call(rail.children);

    // Duplicate the cards once so the loop is seamless.
    originals.forEach(function (card) {
      var clone = card.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('data-shopify-editor-block');
      clone.classList.add('review--clone');
      rail.appendChild(clone);
    });
    wrap.classList.add('is-autoscrolling');

    var loopWidth = 0;
    function measure() {
      var firstClone = rail.children[originals.length];
      loopWidth = firstClone ? firstClone.offsetLeft - rail.children[0].offsetLeft : rail.scrollWidth / 2;
    }
    measure();
    window.addEventListener('resize', measure);

    var pos = rail.scrollLeft;
    var hovering = false, touching = false, focused = false, holdUntil = 0, last = null;

    function paused() { return hovering || touching || focused || Date.now() < holdUntil || document.hidden; }

    function tick(ts) {
      if (last === null) last = ts;
      var dt = Math.min((ts - last) / 1000, 0.1);
      last = ts;
      if (paused()) {
        pos = rail.scrollLeft; // stay in sync with manual scrolling/arrows
      } else {
        pos += speed * dt;
        if (loopWidth > 0 && pos >= loopWidth) pos -= loopWidth;
        rail.scrollLeft = pos;
      }
      if (loopWidth > 0 && rail.scrollLeft >= loopWidth + 1 && paused()) {
        rail.scrollLeft -= loopWidth; pos = rail.scrollLeft;
      }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);

    wrap.addEventListener('mouseenter', function () { hovering = true; });
    wrap.addEventListener('mouseleave', function () { hovering = false; });
    wrap.addEventListener('focusin', function () { focused = true; });
    wrap.addEventListener('focusout', function () { focused = false; });
    rail.addEventListener('touchstart', function () { touching = true; }, { passive: true });
    rail.addEventListener('touchend', function () { touching = false; holdUntil = Date.now() + 2500; }, { passive: true });
    wrap.addEventListener('click', function (e) {
      if (e.target.closest('[data-rail-prev], [data-rail-next]')) holdUntil = Date.now() + 3000;
    });
  }
  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-rail][data-autoscroll]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
